import {message, Space, Skeleton} from "antd";
import {useFormContext} from "react-hook-form";
import {EditStoreServiceBasicFormStepFormValues} from "../schema-validation";
import {FormFieldError} from "../../../../design-system/form-field";
import {useGetStoreServiceContext} from "../context/get-store-service";
import {
  useStoreServiceCoverImagesDelete,
  useStoreServiceUploadCoverImages,
} from "../../../../react-query-hooks/store/services/upload-content";
import {ServiceCoverImagesFormFields} from "../../../../components/offering-form/services/cover-images";
import {
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../features/media";

export function EditStoreServiceCoverImagesUpload() {
  const {
    state: {storeServiceData},
  } = useGetStoreServiceContext();
  const {setValue, watch, formState} =
    useFormContext<EditStoreServiceBasicFormStepFormValues>();
  const productUploadCoverImagesMutation = useStoreServiceUploadCoverImages();
  const productCoverImagesDeleteMutation = useStoreServiceCoverImagesDelete();

  // Fetch cover images via v2 with fallback to embedded data
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "product-service",
    offeringId: storeServiceData.productService.id,
    embedded: storeServiceData.productService.cover_images,
  });

  // Convert domain format back to API format for existing component
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    productCoverImagesDeleteMutation.mutate(
      {mediaId, storeServiceId: offeringId},
      {
        onSuccess: () => {
          const currentCoverImages = watch("cover_images");

          const newValues = currentCoverImages.filter((x) => x.id !== mediaId);
          // console.log({currentCoverImages, newValues});
          setValue("cover_images", newValues);
          message.success("Deleted successfully");
        },
      }
    );
  }

  // Show loading skeleton while fetching cover images
  if (isCoverImagesLoading) {
    return (
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <Skeleton.Image active style={{width: 200, height: 120}} />
        </Space>
      </div>
    );
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ServiceCoverImagesFormFields
          accordionIndex={0}
          serviceData={{
            id: storeServiceData.productService.id.toString(),
          }}
          defaultCoverImages={coverImagesForDisplay}
          deleteCoverImage={handleCoverImagesItemDelete}
          isDeleteLoading={productCoverImagesDeleteMutation.isLoading}
          isUploadLoading={productUploadCoverImagesMutation.isLoading}
          offeringId={storeServiceData.productService.id}
          uploadCoverImages={productUploadCoverImagesMutation}
        />
        <FormFieldError errorMessage={formState.errors.cover_images?.message} />
      </Space>
    </div>
  );
}
